<div id="st-tournament-card-tournament-card" class="tournament-card" [class.tournament-card--compact]="compact" (click)="onCardClick()">
  <div id="st-tournament-card-image-container" class="image-container">
    <div id="st-tournament-card-image-clip" class="image-clip">
      <img [src]="image" alt="Tournament Image" class="card-image">
      <div id="st-tournament-card-media-scrim" class="media-scrim"></div>

      <div id="st-tournament-card-status-badge" class="status-badge" [class]="'status-badge status-' + statusVariant"
        *ngIf="status">
        <span class="status-dot" *ngIf="statusVariant === 'ongoing'"></span>
        {{ getEventStatus(status) | translate }}
      </div>

      <div id="st-tournament-card-alert-box" class="alert-box"
        *ngIf="getClosesIn && getEventStatus(status) === 'REGISTRATION OPEN'">
        <i class="pi pi-clock"></i>
        <span>{{ getClosesIn }}</span>
      </div>
    </div>

    <div id="st-tournament-card-info-row" class="date-chip">
      <i class="pi pi-calendar fw-medium"></i>
      <span class="fw-medium">{{ dateRange }}</span>
    </div>
  </div>

  <div id="st-tournament-card-content-container" class="content-container">
    <h3 class="tournament-title" [title]="title">{{ title | capitalizeTitle }}</h3>

    <button type="button" id="st-tournament-card-location-row" class="location-row" *ngIf="location || distanceKm != null"
      (click)="toggleMapDrawer($event)">
      <i class="bi bi-geo-alt-fill fw-medium"></i>
      @if (distanceKm != null) {
        <span class="fs-12 fw-medium">{{ distanceKm }} km</span>
      }
      @if (location) {
        <span class="fw-medium">{{ location }}</span>
      }
    </button>

    <div id="st-tournament-card-footer" class="card-footer">
      <button type="button" id="st-tournament-card-info-row-1" *ngIf="!isBroadcastRoute" class="registered-row"
        (click)="onViewRegister(); $event.stopPropagation()">
        <i class="pi pi-users fw-medium"></i>
        <span class="fw-medium">{{ registeredCount }} {{'registered'|translate}}</span>
      </button>

      <button class="register-btn" [class.not-open]="getEventStatus(status) !== 'REGISTRATION OPEN'"
        (click)="onRegister(); $event.stopPropagation()">
        <span class="register-btn-label">{{ getEventStatus(status) === 'REGISTRATION OPEN' ? ('register_now'|translate)
          : ('view_event_details'|translate) }}</span>
        <i class="pi pi-arrow-right btn-arrow"></i>
      </button>
    </div>
  </div>
</div>
<stupa-map-options-drawer *ngIf="showMapDrawer" [location]="location" (panelClose)="toggleMapDrawer()"
  (openMap)="handleOpenMap($event)"></stupa-map-options-drawer>